import { useContext } from 'react';

import { ConfiguratorContextProps, ConfiguratorStateContext } from './ConfiguratorContext';

export const useConfigurator = (): ConfiguratorContextProps => {
  const ctx = useContext(ConfiguratorStateContext);
  if (!ctx) {
    throw new Error('Please configure ConfiguratorStateContext before using "useConfigurator()"');
  }
  return ctx;
};
